import React, {Children} from "react";
import {connect} from 'react-redux';
import {
    dateContainInObject,
    focusInput,
    dateContainInObjectStart,
    closeModal,
    dateTimeWithAMPM,
    hasRole
} from 'helper/helperFunctions';
import { Link } from 'react-router-dom';
import {Calendar, momentLocalizer} from 'react-big-calendar';
import moment from 'moment'
import 'react-big-calendar/lib/css/react-big-calendar.css';
import SimpleReactValidator from 'simple-react-validator';
import {Button} from "react-bootstrap";
import {getCallSchedulers, addEventtoScheduler} from 'redux/actions/call-scheduler-actions';
import {objectsConstants as OC} from 'redux/constant/objects-constant';
// import moment_timezone from 'moment-timezone';
// moment_timezone.tz.setDefault('America/New_York');
// var june = moment;
// var time = june.tz('America/New_York');
// console.log("time: " , moment_timezone.tz.setDefault('America/New_York'));
const queryString = require('query-string');
const localizer = momentLocalizer(moment);
console.log("time: " , localizer);
var Modal = require('react-bootstrap-modal');
const today = new Date();

class Scheduler extends React.Component {
    constructor(props) {
        super(props);
        this.validatorScheduler = new SimpleReactValidator({autoForceUpdate: this, locale: 'en'});
        const parsed = queryString.parse(window.location.search);
        const date = moment();

        const estDate = new Date();
        var offset = -540; //Timezone offset for EST in minutes.
        const minTime = new Date(estDate.getTime() + offset*60*1000);
        minTime.setHours(9, 0, 0);

        const estMaxDate = new Date();
        // console.log("max....", estMaxDate);
        var offset = -540; //Timezone offset for EST in minutes.
        const maxTime = new Date(estMaxDate.getTime() + offset*60*1000);
        // console.log("maxTime before....", maxTime);

        maxTime.setHours(17, 30, 0);
        // console.log("maxTime after....", maxTime);

        // const minTime = new Date();
        // minTime.setHours(7, 0, 0);
        // const maxTime = new Date();
        // maxTime.setHours(18, 30, 0);

        this.state = {
            addAppointmentModal: false,
            showAppointmentModal: false,
            events: [],
            newEvent: OC.NEWEVENT,
            showEvent: {},
            slotInfo: {},
            minTime: minTime,
            maxTime: maxTime,
            // canView: parsed.admin ? parsed.admin : false,
            canView: hasRole('admin') ? true : false,
            barcode: parsed.barcode ? parsed.barcode : false,
            userRandom: moment().valueOf(),
        };
        this.getCallSchedulersCall();
    }

    getCallSchedulersCall = () => {
        this.props.getCallSchedulers().then(response => {
            var data = response.data;
            var len = data.length - 1;
            for (var i in data) {
                data[i]['start'] = new Date(data[i]['start']);
                data[i]['end'] = new Date(data[i]['end']);
                if (parseInt(i, 10) === len) {
                    this.setState({events: data})
                }
            }
        });
    }
    slotSelect = (slotInfo) => {
        // console.log("slotInfoo", slotInfo);
        var startHour = moment(slotInfo.start).hour();
        var weekend_day = moment(slotInfo.start).day();
        var endHour = moment(slotInfo.end).hour();
        const {minTime, maxTime} = this.state;
        var minTimeTemp = moment(minTime).hour();
        var maxTimeTemp = moment(maxTime).hour();
        if (!dateContainInObject(this.state.events, slotInfo) && (startHour >= minTimeTemp && endHour <= maxTimeTemp)) {
            this.setState({
                slotInfo: slotInfo,
                newEvent: {...this.state.newEvent, start: slotInfo.start, end: slotInfo.end}
            }, () => {
                // This one also addressed "On the scheduler, it is still allowing people to pick a time or date that has passed and Saturday and Sunday are still able to be selected."
                var estcurrentHour = new Date();
                var offset = -540; //Timezone offset for EST in minutes.
                var currentHour = moment(new Date(estcurrentHour.getTime() + offset*60*1000));
                if ((slotInfo.start >= this.state.minTime && slotInfo.start > currentHour) && (weekend_day >= 1 && weekend_day <= 5)) {
                    this.setState({addAppointmentModal: true});
                }
            });
        }
    }

    handleSchedulerInput = (e) => {
        const {name, value} = e.target;
        const newEventState = {...this.state.newEvent};
        newEventState[name] = value;
        this.setState({newEvent: newEventState});
    }

    handleAgencySubmit = (e) => {
        e.preventDefault();
        if (this.validatorScheduler.allValid()) {
            if (this.state.barcode) {
                console.log("if statement")
                const {newEvent, userRandom, barcode} = this.state;
                this.props.addEventtoScheduler({...newEvent, userRandom: userRandom, barcode: barcode}).then(response => {
                    this.setState({addAppointmentModal: false, newEvent: OC.NEWEVENT}, () => {
                        this.getCallSchedulersCall();
                    })
                });
            } else {
                console.log("else statement")
                const {newEvent, userRandom, barcode} = this.state;
                this.props.addEventtoScheduler({...newEvent, userRandom: userRandom}).then(response => {
                    this.setState({addAppointmentModal: false, newEvent: OC.NEWEVENT}, () => {
                        this.getCallSchedulersCall();
                    })
                });
            }
        } else {
            // focusInput(this.validatorScheduler.getErrorMessages());
            this.validatorScheduler.showMessages();
            this.forceUpdate();
        }
    }

    eventSelect = (event) => {
        console.log("eventSelect", event);
        var startHour = moment(event.start).hour();
        var endHour = moment(event.end).hour();
        const {minTime, maxTime, canView} = this.state;
        var minTimeTemp = moment(minTime).hour();
        var maxTimeTemp = moment(maxTime).hour();
        if ((startHour >= minTimeTemp && endHour <= maxTimeTemp) && canView) {
            this.setState({showEvent: event, showAppointmentModal: true});
        }

    }

    componentDidUpdate(prevProps, prevState) {
        if (prevState.showAppointmentModal && !this.state.showAppointmentModal) {
            this.setState({showEvent: {}});
        }
        // console.log("jjjjjjj", this.state.newEvent)
        // if (this.state.barcode && this.state.newEvent.length > 0 && !this.state.newEvent.includes('barcode')) {
        //     console.log("dddd", this.state.newEvent.includes('barcode'))
        //     const newEventState = {...this.state.newEvent};
        //     newEventState['barcode'] = this.state.barcode;
        //     this.setState({newEvent: newEventState}, () => { console.log("state updated" ,this.state.newEvent)});
        // }
    }

    render() {
        this.validatorScheduler.purgeFields();
        const {
            addAppointmentModal,
            events,
            newEvent,
            showAppointmentModal,
            showEvent,
            minTime,
            maxTime,
            canView,
            userRandom
        } = this.state;


        return (
            <React.Fragment>
                <Calendar
                    selectable
                    localizer={localizer}
                    className="mb-md"
                    events={events}
                    startAccessor="start"
                    endAccessor="end"
                    onSelectSlot={(slotInfo) => this.slotSelect(slotInfo)}
                    onSelectEvent={(event) => {
                        this.eventSelect(event)
                    }}
                    views={['week']}
                    defaultView='week'
                    components={{
                        timeSlotWrapper: ({children, value}) =>
                            React.cloneElement(
                                Children.only(children), {
                                    style: {
                                        ...children.style,
                                        backgroundColor: dateContainInObjectStart(events, value) ? '#ccc' : '',
                                    },

                                }
                            ),
                        event: ({event}) => {
                            return (
                                <React.Fragment>
                                    {
                                        (canView || event.userRandom == userRandom)
                                            ?
                                            <span>
                                            <strong>{`${event.name}`}</strong>
                                        </span>
                                            :
                                            <span></span>
                                    }
                                </React.Fragment>
                            )
                        }
                    }}
                    min={minTime}
                    max={maxTime}
                />
                <Modal backdrop={'static'} show={showAppointmentModal}
                       onHide={closeModal.bind(this, "showAppointmentModal")} aria-labelledby="ModalHeader">
                    <Modal.Header closeButton>
                        <Modal.Title id='ModalHeader' className="headerTitle twenty22">Task</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <div className="row">


                            <div className='form-group'>
                                <div className="clearfix">
                                    <span></span>
                                    <div className="col-md-12 lbl_container">
                                        <label htmlFor="name">Start Time</label>
                                    </div>

                                    <div className="col-md-12">
                                        {
                                            dateTimeWithAMPM(showEvent.start)
                                        }
                                    </div>
                                    <span></span>
                                </div>
                            </div>

                            <div className='form-group'>
                                <div className="clearfix">
                                    <span></span>
                                    <div className="col-md-12 lbl_container">
                                        <label htmlFor="name">End Time</label>
                                    </div>

                                    <div className="col-md-12">
                                        {
                                            dateTimeWithAMPM(showEvent.end)
                                        }
                                    </div>
                                    <span></span>
                                </div>
                            </div>
                            {
                                showEvent.barcode &&
                                <div h={console.log("showEvent", showEvent.barcode)} className='form-group' id="desc">
                                    <div className="clearfix">
                                        <span></span>
                                        <div className="col-md-12 lbl_container">
                                            <label htmlFor="name">barcode</label>
                                        </div>

                                        <div className="col-md-12">
                                            <Link to={'/Admin/' + showEvent.order_id + '/order-edit'} className="blue_link barcode" target="_blank">
                                                 {showEvent.barcode}
                                            </Link>
                                        </div>
                                        <span></span>
                                    </div>
                                </div>
                            }
                            <div className='form-group' id="desc">
                                <div className="clearfix">
                                    <span></span>
                                    <div className="col-md-12 lbl_container">
                                        <label htmlFor="name">name</label>
                                    </div>

                                    <div className="col-md-12">
                                    {
                                        showEvent.name
                                    }
                                    </div>
                                    <span></span>
                                </div>
                            </div>
                            <div className='form-group' id="desc">
                                <div className="clearfix">
                                    <span></span>
                                    <div className="col-md-12 lbl_container">
                                        <label htmlFor="name">email</label>
                                    </div>

                                    <div className="col-md-12">
                                        {showEvent.email}
                                    </div>
                                    <span></span>
                                </div>
                            </div>
                            <div className='form-group' id="desc">
                                <div className="clearfix">
                                    <span></span>
                                    <div className="col-md-12 lbl_container">
                                        <label htmlFor="name">phone</label>
                                    </div>

                                    <div className="col-md-12">
                                        {showEvent.phone}
                                    </div>
                                    <span></span>
                                </div>
                            </div>


                        </div>
                    </Modal.Body>
                </Modal>
                <Modal backdrop={'static'} show={addAppointmentModal}
                       onHide={closeModal.bind(this, "addAppointmentModal")} aria-labelledby="ModalHeader">
                    <Modal.Header closeButton>
                        <Modal.Title id='ModalHeader' className="headerTitle twenty22">Scheduler</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <div className="row">
                            <form>
                                <div className='form-group'>
                                    <div className="clearfix">
                                        <span></span>
                                        <div className="col-md-12 lbl_container">
                                            <label htmlFor="name">Start Time</label>
                                        </div>

                                        <div className="col-md-12">
                                            {
                                                dateTimeWithAMPM(newEvent.start)
                                            }
                                        </div>
                                        <span></span>
                                    </div>
                                </div>

                                <div className='form-group'>
                                    <div className="clearfix">
                                        <span></span>
                                        <div className="col-md-12 lbl_container">
                                            <label htmlFor="name">End Time</label>
                                        </div>

                                        <div className="col-md-12">
                                            {
                                                dateTimeWithAMPM(newEvent.end)
                                            }
                                        </div>
                                        <span></span>
                                    </div>
                                </div>
                                <div className='form-group'>
                                    <div className="clearfix" id="name">
                                        <span></span>
                                        <div className="col-md-12 lbl_container">
                                            <label htmlFor="name">Name</label>
                                        </div>

                                        <div className="col-md-12">
                                            <input autoFocus type="text" name="name" className="form-control"
                                                   value={newEvent.name} onChange={this.handleSchedulerInput}/>
                                            {
                                                this.validatorScheduler.message('name', newEvent.name, 'required')
                                            }
                                        </div>
                                        <span></span>
                                    </div>
                                </div>
                                <div className='form-group' id="email">
                                    <div className="clearfix">
                                        <span></span>
                                        <div className="col-md-12 lbl_container">
                                            <label htmlFor="email">Email</label>
                                        </div>

                                        <div className="col-md-12">
                                            <input autoFocus type="text" name="email" className="form-control"
                                                   value={newEvent.email} onChange={this.handleSchedulerInput}/>
                                            {
                                                this.validatorScheduler.message('email', newEvent.email, 'required|email')
                                            }
                                        </div>
                                        <span></span>
                                    </div>
                                </div>
                                <div className='form-group' id="title">
                                    <div className="clearfix">
                                        <span></span>
                                        <div className="col-md-12 lbl_container">
                                            <label htmlFor="name">Phone</label>
                                        </div>

                                        <div className="col-md-12">
                                            <input autoFocus type="text" name="phone" className="form-control"
                                                   value={newEvent.phone} onChange={this.handleSchedulerInput}/>
                                            {
                                                this.validatorScheduler.message('phone', newEvent.phone, 'required')
                                            }
                                        </div>
                                        <span></span>
                                    </div>
                                </div>
                                <div className="text-center">
                                    <Button type='button' onClick={this.handleAgencySubmit} form="agency-form"
                                            className="backButton pt-sm no_radius pb-sm success btn btn-lg btn-info ml-sm mt-sm">Save</Button>
                                </div>
                            </form>
                        </div>
                    </Modal.Body>
                </Modal>
            </React.Fragment>
        );
    }
}


const mapDispatchToProps = dispatch => {
    return ({
        getCallSchedulers: () => {
            return dispatch(getCallSchedulers())
        },
        addEventtoScheduler: (data) => {
            return dispatch(addEventtoScheduler(data))
        },

    });
};

function mapStateToProps(state) {
    return {};
}

export default Scheduler = connect(mapStateToProps, mapDispatchToProps)(Scheduler);
